module.exports = __webpack_public_path__ + "static/media/light-exit-icon.ca288ef6.svg";